import React from 'react';
import PropTypes from 'prop-types';

import { StyleError, IconAnimated, StyleUploadText } from './style';
import { Loader, LoaderLight } from '../../../../assets/images/index';

const Loading = ({ size, color, txt, className }) => {
  let loaderType = null;

  switch (color) {
    case 'dark':
      loaderType = Loader;
      break;

    case 'light':
      loaderType = LoaderLight;
      break;
    default:
      break;
  }

  return (
    <StyleError className={className}>
      <IconAnimated svg={loaderType} size={size} />
      <StyleUploadText color={color}>{txt}</StyleUploadText>
    </StyleError>
  );
};

Loading.propTypes = {
  className: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  txt: PropTypes.string
};

Loading.defaultProps = {
  size: 'l',
  color: 'dark',
  txt: 'Cargando'
};

export default Loading;
